import ProEvent2 from "../../../../src/events/2021/11/event-pro-content/main";
import * as React from 'react';
export default {
  ProEvent2,
  React
};